"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _providerEvents = _interopRequireDefault(require("wix-art-store-3rd-party/dist/src/sdk/providerEvents"));
var _arrow = _interopRequireDefault(require("./arrow"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var ProductsList = function ProductsList(props) {
  var data = props.data,
    onProviderAction = props.onProviderAction;
  return /*#__PURE__*/_react["default"].createElement("div", {
    onClick: function onClick(e) {
      var node = e.target;
      var attr = null;
      var i = 5;
      do {
        if (node && node.getAttribute) {
          attr = node.getAttribute('data-index');
        }
        i--; // Prevent infinit loop
        node = node.parentNode;
      } while (node && !attr && i !== 0);
      var index = parseInt(attr);
      var item = data[index];
      onProviderAction(_providerEvents["default"].mobileItemClicked, item.dataKey);
    },
    className: 'artstore-products-list-container'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'artstore-table-column artstore-image-column'
  }, data.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      "data-index": index,
      className: 'artstore-table-cell artstore-table-image-container'
    }, /*#__PURE__*/_react["default"].createElement("img", {
      className: 'artstore-table-image',
      src: item.imageSrc
    }));
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'artstore-table-column artstore-devider-column'
  }, data.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      "data-index": index,
      className: 'artstore-table-cell'
    });
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'artstore-table-column artstore-title-column'
  }, data.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      "data-index": index,
      className: 'artstore-table-cell'
    }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
      className: 'artstore-title'
    }, item.title), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("span", {
      className: 'artstore-description'
    }, item.subTitle)));
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'artstore-table-column artstore-arrow-column'
  }, data.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      "data-index": index,
      className: 'artstore-table-cell'
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: 'artstore-arrow-container'
    }, (0, _arrow["default"])()));
  })));
};
var _default = exports["default"] = ProductsList;